import { UnifiedFeed } from "./UnifiedFeed";

export const Social = () => {
    return <UnifiedFeed />;
};
